import { ContainerComponent, wrap } from 'AppReact';
import Controller from './controller';
import { FooterWrapper } from './wrappers';
import { FlexCenterWrapper } from 'wrappers';
import { Text, NoWrap } from 'atoms';
import internalState from './internalState';
import CountDropdown from '../countDropdown';
import PageSelector from '../pageSelector';
import getIsMobile from 'components/atoms/utils/getIsMobile';

const isMobile = getIsMobile();

export const definition = {
  name: 'FooterContainer',
  controller: Controller,
  initialProps: ({ pageNumber, pageSize, total, displayItemsCount }) => ({ pageNumber, pageSize, total, displayItemsCount }),
  props: internalState,
  elements: [
    {
      wrapper: FooterWrapper,
      name: '__transparent__',
      elements: [


        {
          component: PageSelector,
          name: 'PageSelector',
          bindings: ({ pageNumber, pageSize, total }) => ({ pageNumber, pageSize, total })
        },
        {
          wrapper: FlexCenterWrapper,
          name: 'PageSizeSelector',
          elements: [
            {
              component: Text,
              name: 'View',
              displayValue: ({ }) => 'View',
              bindings: () => ({})
            },
            {
              component: CountDropdown,
              name: 'CountDropdown',
              bindings: ({ pageSize }) => ({ pageSize })
            },
            {
              component: NoWrap,
              name: 'Items',
              renderIf: ({ }) => !isMobile,
              displayValue: ({ }) => 'items per page',
              bindings: () => ({})
            }
          ]
        },
        {
          component: Text,
          name: 'OrdersCount',
          renderIf: ({ }) => !isMobile,
          displayValue: ({ pageNumber, pageSize, total, displayItemsCount }) => {
            return `${pageNumber * pageSize + 1} - ${pageNumber * pageSize + displayItemsCount} out of ${total} items`;
          },
          bindings: () => ({})
        }
      ]
    }
  ]
};

export default ContainerComponent(definition);